import { Outlet } from 'react-router-dom'
import { AdminSidebar } from '../../components/Admin'

const AdminLayout = () => {
  return (
    <div className="flex min-h-screen bg-dark-950">
      <AdminSidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}

export default AdminLayout
